export default __webpack_public_path__ + "static/media/30labs.019aaf5f.svg";